import Page from "./Page";

export default class PageResponse {
  constructor(public status: number, public data: Page, public error?: Error) {}
}
